export default {
  logs: 'Server logs',
  configuration: 'Configurations',
  settings: {
    title: 'General settings'
  },
  input_config: {
    title: 'Input configuration'
  },
  output_config: {
    title: 'Output configuration'
  },
  preprocessor: {
    title: 'PreProcessor'
  },
  postprocessor: {
    title: 'PostProcessor'
  },
  local_db: {
    title: 'Local DB'
  },
  visual_sample: {
    title: 'Visual sample'
  },
  stream: {
    title: 'Stream'
  },
  model: {
    title: 'Model',
    upload_image_sample: 'upload an image sample',
    remove: 'Remove model',
    reset: 'Reset parameters to default',
    add_model: 'Add a model',
    library: 'Models library'
  },
  models: {
    title: 'Models'
  },
  sources: {
    title: 'Sources'
  },
  source: {
    title: 'Source'
  },
  pipelines: {
    title: 'Processing',
    add_new: 'Create new processing configuration'
  },
  outputs: {
    title: 'Outputs'
  },
  table: {
    created: 'Created',
    name: 'Name',
    status: 'Status',
    inputs: 'Assets',
    host: 'Local IP / Connected from',
    server_id: 'Server ID',
    server_type: 'Type',
    model: 'Model',
    start: 'Run/Stop',
    remove: 'Remove',
    piplinesOf: 'pipelines of',
    commonModel: 'common model'
  },
  input: {
    name: 'Name',
    model: 'Choose model',
    notes: 'Notes'
  },
  actions: {
    run: 'Run',
    stop: 'Stop',
    delete: 'Delete'
  }
}
